import { keysToCamelCase } from "zod-to-camel-case";

import type {
  OverridesAndExceptions,
  OverridesAndExceptionsCamel,
} from "@/schema/published/overridesAndExceptions/overridesAndExceptions.schema";

export const overridesAndExceptionsFixture = ({
  overrides = {},
}: {
  overrides?: Partial<OverridesAndExceptions>;
} = {}): OverridesAndExceptions => ({
  overrides_and_exceptions_id: 1,
  select_by_programme_fields: [{ subject_id: 7, keystage_id: 3 }],
  select_by_features: [{ pe_practical: true }],
  actions: {
    exclusions: ["pupilSubjectListingQuery"],
    is_pe_practical: true,
  },
  description: "PE practical lessons override",
  used_by_queries: ["all pupil queries"],
  created_at: "2024-01-01T00:00:00.000Z",
  updated_at: "2024-01-01T00:00:00.000Z",
  ...overrides,
});

export const overridesAndExceptionsFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<OverridesAndExceptionsCamel>;
} = {}): OverridesAndExceptionsCamel => ({
  ...keysToCamelCase(overridesAndExceptionsFixture()),
  ...overrides,
});

export default overridesAndExceptionsFixture;
